<template>
  <div class="pop" v-if="popType">
    <div class="popup-bg"></div>
    <div class="popup-container">
      <div style="display: flex; justify-content: space-between; padding: 16px; border-bottom: 1px solid #f5f5f5; font-size: 16px; font-weight: bold">
        <div style="color: #303133; font-size: 18px">温馨提示</div>
        <div class="close" style="font-weight: 400; font-size: 18px; color: #909399; cursor: pointer" @click="close">x</div>
      </div>
      <p style="color: #606266; margin: 24px 0 24px 8px">您有订单信息尚未保存，是否退出当前编辑页面？</p>
      <div class="btn-group">
        <div class="btn btn1" @click="close">取消</div>
        <div class="btn btn2" @click="enter">确认退出</div>
      </div>
    </div>
  </div>
</template>

<script>
import { oss_url_common } from '@/utils'
import { openQQ } from '@/utils/functions'

export default {
  name: 'Popup',
  props: {
    popType: Boolean
  },
  data() {
    return {
      oss_url_common,
      isMove: false,
      right: '10px',
      bottom: '131px'
    }
  },
  mounted() {},
  methods: {
    close() {
      this.$emit('close')
    },
    enter() {
      this.$emit('enter')
    },
    handleClick() {
      if (!this.isMove) {
        openQQ()
      }
    },
    getPostion() {
      let position = localStorage.getItem('ContactQQPostion')
      if (!position) return
      let arr = position.split(',')
      if (arr.length !== 2) return
      this.right = arr[0]
      this.bottom = arr[1]
    }
  }
}
</script>

<style lang="scss" scoped>
.pop {
  position: absolute;
  z-index: 20;
  height: 100%;
}

.pop .popup-bg {
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  height: 100%;
  z-index: 1;
}

.pop .popup-container {
  position: fixed;
  width: 500px;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: 2;
  background: white;
  border-radius: 10px;
}

.pop .popup-container h1 {
  text-align: center;
}

.pop .popup-container p {
  text-align: left;
  padding: 0 10px;
}

.pop .popup-container .btn-group {
  display: flex;
  justify-content: right;
  padding-top: 40px;
  margin: 24px;
  float: right;
}

.pop .popup-container .btn-group .btn {
  flex-shrink: 0;
  flex: 1;
  max-width: 55px;
  min-width: 55px;
  min-height: 31px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  font-size: 12px;
}

.pop .popup-container .btn-group .btn:first-child {
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  max-height: 31px;
  margin-right: 10px;
}
.btn-group {
  .btn1:hover {
    background: #ecf5ff !important;
    border: 1px solid #c6e2ff !important;
    color: #409eff !important;
  }
  .btn2:hover {
    background: #79bbff !important;
    border: 1px solid #79bbff !important;
    color: #fff !important;
  }
  .btn2 {
    min-width: 80px !important;
  }
}

.pop .popup-container .btn-group .btn:last-child {
  cursor: pointer;
  color: #fff;
  background-color: #409eff;
  border: 1px solid #409eff;

  max-height: 31px;
}
</style>
